<template>
    <div class="container">
        <div class="nav">
            <div class="left">
                资源详情
            </div>
            <div class="right">
                <el-button round v-if="userType === USER_TYPE.PROVIDER"  @click="routerChange(2)">
                    <i class="iconfont icon-edit" style="position: relative;top: 1px;"></i> 编辑
                </el-button>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <div class="left">{{resDetail.name}}</div>
                <div class="right">
                    <img src="../../assets/images/login-s.png" alt="">
                </div>
            </div>
            <div class="type">
                <div class="left">
                    资源名称：<span>{{resDetail.name}}</span>
                </div>
                <div class="right">
                    主题名称：<span>{{resDetail.topic}}</span>
                </div>
            </div>
            <div class="type">
                <div class="left">
                    资源类型：<span>{{resDetail.type | resourceTypeFilter}}</span>
                </div>
                <div class="right">
                    标签：<span>{{resDetail.labels || '无'}}</span>
                </div>
            </div>
            <div class="config">
                <div class="config-watermark"></div>
                <div class="config-item" v-for="item of resDetail.config" :key="item.id">
                    <template v-if="item.content.length">
                        <div class="config-name">
                            {{item.title}}
                        </div>
                        <div class="config-content">
                            <div class="form" v-if="item.type === 'form'">
                                <div class="form-item" v-for="(formItem, index) of item.content" :key="index">
                                    {{formItem.name}}：
                                    <span class="form-item-content">
                                        <template v-if="Array.isArray(formItem.value)">
                                            {{formItem.value.join(` ~ `)}}
                                        </template>
                                        <template v-else>
                                            {{formItem.value}}
                                        </template>
                                    </span>
                                </div>
                            </div>
                            <div class="ul" v-if="item.type === 'ul'">
                                <div class="li" v-for="(formItem, index) of item.content" :key="index">
                                    {{ item.content.length === 1 ? '' : (index + 1) + '.'}} {{formItem.value}}
                                </div>
                            </div>
                            <div class="ul-jx" v-if="item.type === 'ul-jx'">
                                <div class="edit-li-jx" v-for="(formItem, index) of item.content" :key="index">
                                    <div class="no arrow">0{{index + 1}}</div>
                                    <div class="edit-li-jx-content">
                                        <div class="edit-li-jx-content-title">
                                            <div class="left">
                                                {{formItem.title}}
                                            </div>
                                        </div>
                                        <div class="edit-li-jx-item" v-for="(items, ii) of formItem.list" :key="ii">
                                            <div class="edit-li-jx-item-title">{{items.name}}</div>
                                            <div class="edit-li-jx-item-content" v-html="items.value">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="config-item config-item-files" v-if="resDetail.files && resDetail.files.length">
                    <div class="config-mater-title">
                        <div class="config-name">
                            附件材料
                        </div>
                        <el-button class="button" type="plain" @click="recoverOssFile">文件取回</el-button>
                    </div>
                    <div class="config-content">
                        <div class="ul file-ul" style="border-radius:4px;">
                            <div class="li file" v-for="(file, index) of notImgSrcList" :key="index" @click="handleViewFile(file)">
                                <div class="file-icon">
                                    <img v-if="file.icon_type === 'video'" src="../../assets/images/res/video-color.png" />
                                    <img v-else-if="file.icon_type === 'audio'" src="../../assets/images/res/music-color.png" style="margin-bottom:2px;" />
                                    <img v-else-if="file.icon_type === 'ppt'" src="../../assets/images/res/ppt-color.png" />
                                    <img v-else-if="file.icon_type === 'document'" src="../../assets/images/res/text-color.png" style="margin-bottom:1px;" />
                                    <img v-else-if="file.icon_type === 'package'" src="../../assets/images/res/file-color.png" />
                                    <img v-else-if="file.icon_type === 'image'" src="../../assets/images/res/image-color.png" />
                                    <img v-else-if="file.icon_type === 'excle'" src="../../assets/images/res/excle-color.png" />
                                    <img v-else src="../../assets/images/res/file-color.png" />
                                </div>
                                <div class="file-name">{{file.name}}</div>
                                <span class="size">({{file.size | fileSizeFormat}})</span>
                            </div>
                            <div class="image-preview" v-if="imgSrcList.length">
                                <div class="img-box" v-for="(item, imgIndex) in imgSrcList" :key="'img'+imgIndex">
                                    <el-image :src="item.path" :preview-src-list="imgSrcPathList" fit='cover'></el-image>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Core from '@/core';
import axios from 'axios'
export default {
    data() {
        return {
            id: '',
            resDetail: {},
            uploadSuffix: Core.Const.UPLOAD_FILE_SUFFIX,
            userType: Core.Data.getUserType(),
            USER_TYPE: Core.Const.USER_TYPE,
            imgSrcList: [],
            notImgSrcList: [],
        };
    },
    computed: {
        imgSrcPathList() {
            let imgSrcPathList = []
            this.imgSrcList.forEach(item => {
                imgSrcPathList.push(item.path)
            })
            return imgSrcPathList
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.getResourceDetail();
    },
    methods: {
        getResourceDetail() {
            Core.Api.Resource.detail(this.id).then((res) => {
                res.resource.config = JSON.parse(res.resource.config);
                res.resource.files = JSON.parse(res.resource.files);
                this.imgSrcList = []
                this.notImgSrcList = res.resource.files.filter((item) => {
                    item.icon_type = Core.Utils.fileTypeFilter(item.name);
                    if (item.icon_type === 'image') {
                        this.imgSrcList.push(item)
                    }
                    return item.icon_type !== 'image'
                });
                this.resDetail = res.resource;
            });
        },
        routerChange(key, q = '') {
            switch (key) {
                case 1:
                    this.$router.go(-1);
                    break;
                case 2:
                    this.$router.replace(`/resources/resources-edit?id=${this.id}`);
                    break;
                case 3:
                    this.$router.push(`/public-part/video-player?source=${q}`);
                    break;
            }
        },
        handleViewFile(file) {
            const href = file.path;
            if ( // 文档 doc/docx  ppt/pptx  excle
                file.icon_type === this.uploadSuffix.DOCUMENT ||
                file.icon_type === this.uploadSuffix.PPT ||
                file.icon_type === this.uploadSuffix.EXCLE
            ) {
                if (file.size > 1024 * 1024 * 10) { // 大于10MB 不预览直接下载
                    window.open(href, '_blank');
                } else {
                    const officeUrl = ` https://view.officeapps.live.com/op/view.aspx?src=${href}`;
                    window.open(officeUrl, '_blank');
                }
            }
            else if (  // 图像 jpg png jpeg
                Core.Utils.fileTypeFilter(file.name) === this.uploadSuffix.IMAGE
            ) {
                this.$imagePreview({
                    url: href,
                    closeColor: '#1D517E',
                    controlBackground: '#1D517E'
                });
            }
            else if (  // 视频
                Core.Utils.fileTypeFilter(file.name) === this.uploadSuffix.VIDEO
            ) {
                this.routerChange(3, href);
            }
            else { // 其他
                window.open(href, '_blank');
            }
        },
        recoverOssFile() {
            const fileArray = this.notImgSrcList.map(i => i.path.split('com/')[1])
            console.log('fileArray>>', fileArray);
            // return
            let data = encodeURIComponent('file_keys') + '=' + encodeURIComponent(fileArray.toString())
            axios.post(Core.Const.NET.URL_POINT + '/file/oss-restore-list', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                this.$message.success("正在进行文件取回, 找回时间预计3-5分钟")
            }).catch(err => {
                this.$message.error(err.message || err)
            })
        }
    },
};
</script>
<style lang="scss" scoped>
@media print{  // 禁止打印
    .container{
        display: none;
    }
}
.container {
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    width: 60vw;
    margin: 0 auto;
    .nav {
        margin: 18px 0;
        font-weight: 500;
        color: rgba(50, 53, 56, 1);
        @include flex(row, space-between, center);
        .left {
            font-size: 20px;
            @include ftb;
            .el-icon-back {
                font-size: 24px;
                color: #1D517E;
                font-weight: 800;
                margin-right: 10px;
                cursor: pointer;
            }
        }
        .right {
            .iconfont.icon-edit {
                position: relative;
                top: 1px;
            }
        }
    }
    .content {
        width: 100%;
        box-sizing: border-box;
        padding: 30px;
        border-radius: 6px;
        border: 1px solid rgba(225, 231, 236, 1);
        background-color: rgba(73, 124, 168, 1);
        position: relative;
        .title {
            width: 100%;
            @include flex(row, space-between, center);
            .left {
                font-size: 24px;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
            }
            .right {
                img {
                    width: 98px;
                    height: 24px;
                }
            }
        }
        .type {
            width: 100%;
            margin: 30px 0 20px 0;
            @include flex(row, space-between, center);
            .left,
            .right {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.3);
                span {
                    color: rgba(255, 255, 255, 1);
                }
            }
        }
        .config {
            width: 100%;
            background-color: rgba(255, 255, 255, 1);
            border-radius: 10px;
            padding: 30px 0;
            &-watermark {
                z-index: 9;
                background-image: url('../../assets/images/Logo-watermark.png');
                background-size: 50%;
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                opacity: .1;
            }
            .config-item {
                position: relative;
                width: 100%;
                z-index: 8;
                &.config-item-files{
                z-index: 10;
                }
                .config-name {
                    width: 106px;
                    height: 34px;
                    box-sizing: border-box;
                    padding-left: 22px;
                    line-height: 34px;
                    background: #dc6f7c;
                    border-radius: 0px 17px 17px 0px;
                    font-size: 16px;
                    font-weight: 500;
                    color: #ffffff;
                }
                .config-content {
                    width: 100%;
                    margin: 20px 0 10px 0;
                    .form {
                        width: 100%;
                        padding: 0 40px;
                        box-sizing: border-box;
                        .form-item {
                            width: 45%;
                            display: inline-block;
                            color: #9aa4ad;
                            margin-bottom: 14px;
                            span {
                                color: #323538;
                                white-space: pre-wrap;
                            }
                        }
                    }
                    .ul {
                        width: 100%;
                        padding: 0 40px;
                        box-sizing: border-box;
                        .li {
                            margin-bottom: 14px;
                            width: 100%;
                            text-align: justify;
                            white-space: pre-wrap;
                            &.file {
                                margin-bottom: 0;
                                height: 40px;
                                line-height: 40px;
                                @include ftb;
                                border-bottom: 1px solid rgba(234, 238, 241, 1);
                                border-left: 1px solid rgba(234, 238, 241, 1);
                                border-right: 1px solid rgba(234, 238, 241, 1);
                                &:first-of-type {
                                    border-top: 1px solid rgba(234, 238, 241, 1);
                                    border-radius: 4px 4px 0 0;
                                }
                                &:last-of-type {
                                    border-radius: 0 0 4px 4px;
                                }
                                cursor: pointer;
                                .file-icon {
                                    @include ftb;
                                    img {
                                        width: 14px;
                                        height: 14px;
                                        margin: 0 10px;
                                    }
                                }
                                .file-name {
                                    max-width: 70%;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }
                                .size {
                                    color: #9aa4ad;
                                }
                                .icon-btn {
                                    margin-left: auto;
                                }
                            }
                        }
                    }
                    .ul-jx {
                        width: 100%;
                        padding: 0 40px;
                        box-sizing: border-box;
                        .edit-li-jx {
                            width: 100%;
                            margin-bottom: 20px;
                            @include fj;
                            .no {
                                width: 54px;
                                height: 44px;
                                text-align: center;
                                line-height: 44px;
                                background: #f9fafc;
                                // border: 1px solid rgba(234, 238, 241, 1);
                                font-size: 20px;
                                color: #dc6f7c;
                                font-weight: 600;
                                margin-left: 20px;
                                border-radius: 4px;
                                position: relative;
                                &.arrow {
                                    &::after {
                                        content: '';
                                        position: absolute;
                                        right: -13px;
                                        bottom: 0;
                                        width: 0;
                                        height: 0;
                                        border-left: 13px solid#f9fafc;
                                        border-top: 22px solid transparent;
                                        border-bottom: 22px solid transparent;
                                    }
                                }
                            }
                            .edit-li-jx-content {
                                width: calc(100% - 100px);
                                border-radius: 4px;
                                border: 1px solid rgba(234, 238, 241, 1);
                                .edit-li-jx-content-title {
                                    width: 100%;
                                    box-sizing: border-box;
                                    padding: 0 14px;
                                    height: 44px;
                                    line-height: 44px;
                                    background: rgba(249, 250, 252, 1);
                                    font-size: 14px;
                                    font-weight: 600;
                                    color: rgba(50, 53, 56, 1);
                                    border-bottom: 1px solid
                                        rgba(234, 238, 241, 1);
                                    position: relative;
                                }
                                .edit-li-jx-item {
                                    display: flex;
                                    border-bottom: 1px solid
                                        rgba(234, 238, 241, 1);
                                    &:last-of-type {
                                        border: none;
                                    }
                                    .edit-li-jx-item-title {
                                        width: 84px;
                                        text-align: center;
                                        background: rgba(249, 250, 252, 1);
                                        font-size: 14px;
                                        color: rgba(109, 116, 123, 1);
                                        @include flex(row, center, center);
                                        border-right: 1px solid
                                            rgba(234, 238, 241, 1);
                                    }
                                    .edit-li-jx-item-content {
                                        width: calc(100% - 84px);
                                        min-height: 44px;
                                        font-size: 14px;
                                        line-height: 1.5;
                                        color: rgba(50, 53, 56, 1);
                                        box-sizing: border-box;
                                        padding: 14px;
                                        text-align: justify;
                                        white-space: pre-wrap;
                                    }
                                }
                            }
                        }
                    }
                    .image-preview{
                        margin-top: 10px;
                        @include flex(row, flex-start, center);
                        flex-wrap: wrap;
                        border-radius: 0px;
                        border: 1px solid rgba(225, 231, 236, 1);
                        padding: 10px;
                        width: 100%;
                        box-sizing: border-box;
                        .img-box{
                            @include flex(row, center, center);
                            border-radius: 4px;
                            border: 1px solid rgba(225, 231, 236, 1);
                            width: 150px;
                            height: 150px;
                            overflow: hidden;
                            margin: 10px;
                            .el-image{
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }
                .config-mater-title {
                    display: flex;
                    align-items: center;
                    .button {
                        margin-left: auto;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}

</style>

<style lang="scss">
    .hevue-wrap{
        z-index: 10;
    }
</style>